import React, { useState } from "react";
import * as yup from "yup";
import InputField from "Components/CommonComponents/InputField";
import { Checkbox, FormControlLabel } from "@mui/material";
import ButtonComponent from "Components/CommonComponents/button";

import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { loginAction } from "Redux/Actions/AuthActions";
import { AssestsIcon } from "../../Constants/AssetsConstants";

const LoginComponent = () => {
  const dispatch = useDispatch();
  const initialValues = {
    email: "",
    password: "",
  };
  const LoginSchema = yup.object().shape({
    email: yup.string().email("Invalid email").required("User Email is Required"),
    password: yup
      .string()
      .required("Please Enter your password")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character",
      ),
  });

  const [showPassword, setShowPassword] = useState(false);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={LoginSchema}
      onSubmit={(values) => dispatch(loginAction(values))}
    >
      {({ setFieldValue, values }) => (
        <Form>
          <>
            <p className="logo-p text-center">FST</p>
            <div className="login-container">
              <InputField
                name="username"
                type="email"
                label="Username"
                maxWidth="320px"
                icon={AssestsIcon.ICON_PROFILE}
                onChange={(event) => setFieldValue((values.email = event.target.value))}
              />
              <InputField
                name="password"
                type={showPassword ? "text" : "password"}
                label="Password"
                maxWidth="320px"
                icon={AssestsIcon.ICON_PASSWORD}
                onChange={(event) => setFieldValue((values.password = event.target.value))}
                iconOnClick={() => setShowPassword(!showPassword)}
              />
              <div className="d-flex justify-content-between align-items-center">
                <FormControlLabel control={<Checkbox />} label="Remember Me" />

                <p className="forgot-password-p">Forgot Password</p>
              </div>

              <ButtonComponent title="SIGN IN" type="submit" />
            </div>
          </>
        </Form>
      )}
    </Formik>
  );
};

export default LoginComponent;
